import { Plugin, PluginKey } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

const findHashtags = (doc) => {
  const hashtag = /(^|\s)(#[\w\p{L}]+)\b/giu;
  const decorations = [];

  doc.descendants((node, position) => {
    if (!node.text) {
      return;
    }

    Array.from(node.text.matchAll(hashtag)).forEach((match) => {
      const value = match[2];
      const index = (match.index || 0) + match[1].length;
      const from = position + index;
      const to = from + value.length;
      const decoration = Decoration.inline(from, to, {
        nodeName: "span",
        "data-mark": "",
        "data-type": "hashtag",
      });

      decorations.push(decoration);
    });
  });

  return DecorationSet.create(doc, decorations);
};

export const hashtagHighlighterPluginKey = new PluginKey("hashtag-highlighter");

export const hashtagHighlighterPlugin = () =>
  new Plugin({
    key: hashtagHighlighterPluginKey,
    state: {
      init(_, { doc }) {
        return findHashtags(doc);
      },
      apply(transaction, oldState) {
        return transaction.docChanged
          ? findHashtags(transaction.doc)
          : oldState;
      },
    },
    props: {
      decorations(state) {
        return this.getState(state);
      },
    },
  });
